var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningCentreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6257",
    "data-name": "Group 6257",
    transform: "translate(1551.049 -426.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M-1533.211,439.856a2.075,2.075,0,0,0-2.21-.361,2.468,2.468,0,0,0-1.2-1.5.586.586,0,0,0-.785.218.552.552,0,0,0,.225.762,1.294,1.294,0,0,1,.462.421,1.918,1.918,0,0,0-1.833.457,2.6,2.6,0,0,0-.606,1.064,3.232,3.232,0,0,0,.135,2.17,4.8,4.8,0,0,0,.812,1.255,1.927,1.927,0,0,0,1.47.785,4.26,4.26,0,0,0,.86-.152,1.937,1.937,0,0,0,2.329-.632,4.781,4.781,0,0,0,.811-1.255h0a3.022,3.022,0,0,0-.47-3.234Z",
    transform: "translate(-3.756 -3.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M-1544.333,438.478a6.77,6.77,0,0,0-3.088.4,6.774,6.774,0,0,0-3.089-.4.619.619,0,0,0-.54.62v4.887a.615.615,0,0,0,.676.62,4.994,4.994,0,0,1,2.686.412.594.594,0,0,0,.556-.013,5.311,5.311,0,0,1,2.661-.4.615.615,0,0,0,.677-.62V439.1A.619.619,0,0,0-1544.333,438.478Zm-5.5,4.853v-3.638a5.1,5.1,0,0,1,1.8.277v3.579a6.784,6.784,0,0,0-1.8-.219Zm4.823,0a6.92,6.92,0,0,0-1.8.219v-3.579a5.115,5.115,0,0,1,1.8-.277Z",
    transform: "translate(0 -3.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M-1547.821,433.488a.563.563,0,0,0,.811,0l2.569-2.636a2.286,2.286,0,0,0,0-3.175,2.151,2.151,0,0,0-2.975-.115,2.15,2.15,0,0,0-2.974.115,2.29,2.29,0,0,0,0,3.175Z",
    transform: "translate(-0.006 -0.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M-1532.785,427.516c-.045-.013.28.051-3.908-.741a.546.546,0,0,0-.646.539v2.638a1.643,1.643,0,0,0-.564-.1,1.661,1.661,0,0,0-1.655,1.663,1.661,1.661,0,0,0,1.655,1.663,1.661,1.661,0,0,0,1.655-1.663v-3.541l2.777.525v2.183a1.643,1.643,0,0,0-.564-.1,1.661,1.661,0,0,0-1.655,1.663,1.661,1.661,0,0,0,1.655,1.663,1.661,1.661,0,0,0,1.654-1.663c0-.032,0-4.174,0-4.206a.546.546,0,0,0-.4-.525Zm-5.118,4.567a.566.566,0,0,1-.564-.567.566.566,0,0,1,.564-.567.566.566,0,0,1,.564.567A.566.566,0,0,1-1537.9,432.083Zm3.869.731a.566.566,0,0,1-.564-.567.566.566,0,0,1,.564-.567.566.566,0,0,1,.564.567A.566.566,0,0,1-1534.034,432.814Z",
    transform: "translate(-3.669)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningCentreIcon);
export default __webpack_public_path__ + "static/media/learningCentre_icon.c99746dd5cad3648737539df55dcedd2.svg";
export { ForwardRef as ReactComponent };